export const text = '#191919';
export const hover = '#E62E43';
export const hoverNd = '#8C263D';
export const Black = "#191919";
export const title = `"Butler"`;
export const Transition = "cubic-bezier(0.4, 0, 0, 1)"
export const White = "#FFF"
